import './App.css';
import Navbar from './components/Navbar';
import Slider from 'react-slick';
import { useState, useEffect } from 'react';
import {getHomePage, getPartners} from './api/api.service';
import {getMediaLink} from './api/utils';

function LandingPage() {
  const [currentLogoIndex, setCurrentLogoIndex] = useState(0);
  const [homePage, setHomePage] = useState();
  const [partners, setPartners] = useState();
    
      const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      };

      const logos = [
        '/LOGO_ALICE-01.png',
        '/LOGO_ALICE-02.png',
        '/LOGO_ALICE-03.png',
        '/LOGO_ALICE-05.png',
        '/LOGO_ALICE-06.png',
      ];

      useEffect(() => {
        const interval = setInterval(() => {
          setCurrentLogoIndex((prevIndex) => (prevIndex + 1) % logos.length);
        }, 1000);
    
        return () => clearInterval(interval); // Pulisce l'intervallo quando il componente viene smontato
      }, [logos.length]);


      useEffect(() => {
        const fetchPartners = async () => {
          const data  = await getPartners();
          setPartners(data.data);
        }

        const fetchHomePage = async () => {
          const data  = await getHomePage();
          setHomePage(data.data);
        }

        fetchHomePage();
        fetchPartners();
      }, []);

  return (
    <div className="min-h-screen">
      {/* Header */}
      <Navbar />

      {/* Hero Section */}
      <section className="flex justify-center w-full pt-12 pb-12" style={{
        backgroundImage: 'url("/header.png")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}>
        <div className="text-center p-6 flex flex-col md:flex-row items-center md:items-center w-3/4">
          <div className="md:ml-6 md:w-3/5 text-center md:text-left">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 font-space">
              <img src={logos[currentLogoIndex]} width={'220rem'} alt="Logo" />
              {homePage?.Hero?.Titolo}
            </h2>
            <p className="text-lg text-gray-600 mt-8">
              {homePage?.Hero?.Sottotitolo}
            </p>
            <a 
              href="#contact" 
              className="mt-8 ml-4 inline-block px-4 py-2 shadow-md bg-white text-black border-2 border-black hover:bg-black hover:text-white uppercase text-sm font-semibold"
            >
              Partecipa
            </a>
          </div>
        </div>
      </section>

      <section className="flex justify-center py-16 px-6 bg-white w-full border-t-2 border-b-2 border-black">
        <div className="flex flex-col md:w-3/5 md:text-right">
          <h2 className="text-3xl font-bold text-gray-800 font-space uppercase">{homePage?.CosaEAliceStem?.Titolo}</h2>
          <div className="text-lg text-gray-600 mt-4 w-full flex items-end flex-col">
            <p className="md:w-3/4">
            {homePage?.CosaEAliceStem?.Sottotitolo}
            </p>
          </div>

          {/* Obiettivi Chiave */}
          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
            <div className="p-6">
              <div className="flex justify-center items-center w-16 h-16 mx-auto">
                <img
                  src="/icons/pixel/lightbulb-on.svg"
                  alt="Innovazione Educativa"
                  className="w-3/4"
                  style={{
                    filter: 'invert(57%) sepia(91%) saturate(1741%) hue-rotate(152deg) brightness(103%) contrast(104%)',
                  }}
                />
                <h3 className="text-xl font-semibold text-[#00cfff] mt-4 font-social uppercase ml-4">{homePage?.Obiettivo1?.Titolo}</h3>
              </div>
              <p className="text-black mt-4 text-center">
                {homePage?.Obiettivo1?.Sottotitolo}
              </p>
            </div>
            <div className="p-6">
              <div className="flex justify-center items-center w-16 h-16 mx-auto">
                <img
                  src="/icons/pixel/users.svg"
                  alt="Inclusione Sociale"
                  className="w-3/4"
                  style={{
                    filter: 'invert(70%) sepia(64%) saturate(721%) hue-rotate(42deg) brightness(104%) contrast(112%)',
                  }}
                />
                <h3 className="text-xl font-semibold text-[#71ff00] mt-4 font-social uppercase ml-4">{homePage?.Obiettivo2?.Titolo}</h3>
              </div>
              <p className="text-black mt-4 text-center">
                {homePage?.Obiettivo2?.Sottotitolo}
              </p>
            </div>
            <div className="p-6">
              <div className="flex justify-center items-center w-16 h-16 mx-auto">
              <img
                  src="/icons/pixel/human.svg"
                  alt="Competenze Tecnologiche"
                  className="w-3/4"
                  style={{
                    filter: 'invert(50%) sepia(40%) saturate(4000%) hue-rotate(270deg) brightness(104%) contrast(107%)',
                  }}
                />
                
                <h3 className="text-xl font-semibold text-[#ff53ff] mt-4 font-social uppercase ml-4">{homePage?.Obiettivo3?.Titolo}</h3>
              </div>
              <p className="text-black mt-4 text-center">
                {homePage?.Obiettivo3?.Sottotitolo}
              </p>
            </div>
            <div className="p-6">
              <div className="flex justify-center items-center w-16 h-16 mx-auto">
              <img
                  src="/icons/pixel/radio-signal.svg"
                  alt="Competenze Tecnologiche"
                  className="w-3/4"
                  style={{
                    filter: 'invert(44%) sepia(66%) saturate(3110%) hue-rotate(1deg) brightness(104%) contrast(107%)',
                  }}
                />
                <h3 className="text-xl font-semibold text-[#ff6600] mt-4 font-social uppercase ml-4">{homePage?.Obiettivo4?.Titolo}</h3>
              </div>
              <p className="text-black mt-4 text-center">
                {homePage?.Obiettivo4?.Sottotitolo}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="flex justify-center py-16 px-6 w-full">
        <div className="flex flex-col text-left md:w-3/5">
          <h2 className="text-3xl font-bold text-gray-800 font-space uppercase">{homePage?.LeAttivita?.Titolo}</h2>
          <p className="text-lg text-gray-600 mt-4 md:w-1/2">
            {homePage?.LeAttivita?.Sottotitolo}
          </p>

          {/* Attività Principali */}
          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl">
            {homePage?.ListaAttivita?.map((att) => (
              <div className="p-6 bg-white shadow-lg rounded-lg hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-bold text-gray-800 font-space">{att.Titolo}</h3>
              <p className="text-gray-600 mt-2">
                {att.Sottotitolo}
              </p>
            </div>
            ))}
          </div>
          
        </div>
      </section>

      {/* Sezione Attività Addizionali */}
      <section className="flex justify-center pb-16 px-6 w-full">
        {homePage?.AttivitaAddizionali && (
          <div className="mt-12">
            <h3 className="text-2xl font-bold text-gray-800 font-space">
              In aggiunta, il progetto prevede:
            </h3>
            <ul className="list-disc list-inside mt-4 text-gray-600">
              {homePage.AttivitaAddizionali.map((attivita, index) => (
                <li key={index} className="text-lg">
                  {attivita.Titolo}
                </li>
              ))}
            </ul>
          </div>
        )}
      </section>

      <section className="flex justify-center pb-16 px-6 w-full">
        <div className="text-lg text-gray-600 w-full flex justify-center">
          <a 
            href="#contact" 
            className="inline-block px-4 py-2 shadow-md bg-white text-black border-2 border-black hover:bg-black hover:text-white uppercase text-sm font-semibold"
          >
            Partecipa
          </a>
        </div>
      </section>

      

      {/* Schools Carousel Section */}
      <section className="py-16 px-6 text-center mb-20 border-2 border-black">
        <div className="flex flex-col items-center">
          <h2 className="text-3xl font-bold text-gray-800 font-space uppercase">{homePage?.IPartner?.Titolo}</h2>
          <p className="text-lg text-gray-600 mt-4 md:w-2/5">
            {homePage?.IPartner?.Sottotitolo}
          </p>
        </div>
        <Slider {...settings} className="flex flex-wrap justify-center mt-20 mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 md:w-3/4">
          {partners?.map((partner, index) => (
            <div key={index} className="p-4">
              <div className="h-28 w-auto flex justify-center">
                <img src={getMediaLink(partner.Logo?.url)} alt={partner.Denominazione} className="mx-auto max-w-120-px max-h-120-px self-center"/>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mt-12">{partner.Denominazione}</h3>
            </div>
          ))}
        </Slider>
      </section>

      <section className="py-16 px-6 text-center bg-black">
        <h2 className="text-3xl font-bold text-white font-space uppercase">{homePage?.Caption?.Titolo}</h2>
        <p className="text-lg text-white mt-4">
          {homePage?.Caption?.Sottotitolo}
        </p>
        <div className="mt-8 flex justify-center gap-4">
          <a 
            href="https://orientamento.dingegno.com" 
            className="px-6 py-3 shadow-md bg-white text-black border-2 border-white hover:bg-black hover:text-white uppercase text-sm font-semibold"
          >
            Orientamento
          </a>
          <a 
            href="https://labs.dingegno.com" 
            className="px-6 py-3 shadow-md bg-white text-black border-2 border-white hover:bg-black hover:text-white uppercase text-sm font-semibold"
          >
            Laboratori Remoti
          </a>
        </div>
      </section>

      <section id="contact" className="py-16 px-6 text-center">
        <h2 className="text-3xl font-bold text-gray-800 font-space uppercase">{homePage?.Contatti?.Titolo}</h2>
        <p className="text-lg text-gray-600 mt-4">
          {homePage?.Contatti?.Sottotitolo}
        </p>
        <form className="mt-8 max-w-xl mx-auto text-left">
          <div className="mb-4">
            <label htmlFor="name" className="block text-sm font-semibold text-black">
              Nome e Cognome
            </label>
            <input
              type="text"
              id="name"
              name="name"
              className="w-full mt-2 p-2 border-black border-2"
              placeholder="Inserisci il tuo nome"
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="email" className="block text-sm font-semibold text-black">
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              className="w-full mt-2 p-2 border-black border-2"
              placeholder="Inserisci la tua email"
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="message" className="block text-sm font-semibold text-black">
              Messaggio
            </label>
            <textarea
              id="message"
              name="message"
              className="w-full mt-2 p-2 border-black border-2"
              rows="4"
              placeholder="Scrivi il tuo messaggio"
              required
            ></textarea>
          </div>
          <button
            type="submit"
            className="mt-4 px-4 py-2 shadow-md bg-black text-white border-2 border-black hover:bg-white hover:text-black uppercase text-sm font-semibold"
          >
            Invia
          </button>
        </form>
      </section>

      <hr />

      <footer className="text-center py-6 flex flex-col justify-around items-center w-full">
        <img src='/LOGO_ALICE-01.png' width={'150px'} />
        <p className="font-space">{new Date().getFullYear()} &copy; ALICE STEM</p>
        
        {/* Footer Credits */}
        {homePage?.FooterCredits && (
          <p className="mt-4 p-5 text-sm text-gray-600 text-center lg:w-1/2">
            {homePage.FooterCredits}
          </p>
        )}
      </footer>
    </div>
  );
}

export default LandingPage;
